import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=3b75b5bb&scoped=true"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b75b5bb",
  null
  
)

export default component.exports